import { collarProductIsSupportedInCountry, useLocale } from '../contexts/LocaleContext';
import { inPartnerPromoContext } from '../lib/hardwareFirstPartnerContext';
import * as types from '../types';
import { showNanoVariant } from '../components/NanoBanner/NanoBanner';
import { showRescueGwaVariant } from '../views/RescueLanding/RescueBanner';
import useHardwareFirstCheckout from './useHardwareFirstCheckout';
import useIsReferralCheckoutV2 from './useIsReferralCheckoutV2';

/**
 * Whether this visitor gets the pick-your-fi shop at `/shop`. Partner, referral, rescue and nano
 * contexts keep the classic listing at `/products`: partner promos must not mix with the new pricing
 * model. The in-app shop follows the same flag as the web, so a member buying from the app gets the
 * hardware price and the discounted first term at activation. Mini is the entry tracker, so a market
 * that cannot sell it has no page to show.
 */
export default function useHardwareFirstShop(): boolean {
  const hardwareFirstEnabled = useHardwareFirstCheckout();
  const isReferralV2 = useIsReferralCheckoutV2();
  const { country } = useLocale();

  return (
    hardwareFirstEnabled &&
    !inPartnerPromoContext() &&
    !isReferralV2 &&
    !showRescueGwaVariant() &&
    !showNanoVariant() &&
    collarProductIsSupportedInCountry(types.miniCollarId, country)
  );
}
